import { type } from 'os';
import * as React from 'react';
import SpinnerSVG from '../../assets/images/spinner.svg';

type props = {
  alignmentClass?: string;
};

const Spinner: React.FunctionComponent<props> = ({ alignmentClass }): JSX.Element => {
  return (
    <div
      className={alignmentClass ? alignmentClass : 'z-100 fixed inset-0 overflow-y-auto'}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-overlay flex h-full w-full items-center justify-center">
        <img src={SpinnerSVG} alt="spinner" className="antiClockwiseSpin h-14 w-14" />
      </div>
    </div>
  );
};
export default Spinner;
